import ApiService from "../../services/ApiService";
import { isLoading, setError, setSuccessMessage } from "./uxAction";
import { parseServiceErrors } from "../../helpers/ParseServiceErrors";

export function createJob(
  {
    accountId,
    title,
    description,
    publishDate,
    type,
    onSiteRequired,
    categories,
    skillsRequired,
    minExperience,
    status,
    image,
  },
  callback,
) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokePost(
      process.env.REACT_APP_API_URL + `/proxy-api/admin/api/secured/jobs/`,
      {
        accountId,
        title,
        description,
        publishDate,
        type: type.value,
        onSiteRequired: onSiteRequired.value,
        skillsRequired: skillsRequired
          ? skillsRequired.map((v) => v.label)
          : [],
        categories: categories ? categories.map((v) => v.value) : [],
        minExperience: minExperience.value,
        status: status.value,
        image,
      },
    );

    dispatch(isLoading(false));

    if (resp.status >= 400) {
      let parsedErrors = [];

      if (resp.data?.details) {
        parsedErrors = parseServiceErrors(resp.data);
      } else {
        parsedErrors.push({
          param: "unknown",
          msg: "An error occurred",
        });
      }

      dispatch(setError(parsedErrors));
    } else {
      dispatch(
        setSuccessMessage({
          title: "Success",
          subTitle: "Job has been successfully created",
        }),
      );
      callback();
    }
  };
}

export function updateJob(
  {
    jobId,
    accountId,
    title,
    description,
    publishDate,
    type,
    onSiteRequired,
    categories,
    skillsRequired,
    minExperience,
    status,
    image,
    jobCloses,
    deleteImage,
  },
  callback,
) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokePost(
      process.env.REACT_APP_API_URL +
        `/proxy-api/admin/api/secured/jobs/${jobId}/`,
      {
        accountId,
        title,
        description,
        publishDate,
        type: type.value,
        jobCloses,
        onSiteRequired: onSiteRequired.value,
        skillsRequired: skillsRequired
          ? skillsRequired.map((v) => v.label)
          : [],
        categories: categories ? categories.map((v) => v.value) : [],
        minExperience: minExperience.value,
        status: status.value,
        image,
        delete_image: deleteImage,
      },
    );

    dispatch(isLoading(false));

    if (resp.status >= 400) {
      let parsedErrors = [];
      if (resp.data?.details) {
        parsedErrors = parseServiceErrors(resp.data);
      } else {
        parsedErrors.push({
          param: "unknown",
          msg: "An error occurred",
        });
      }

      dispatch(setError(parsedErrors));
    } else {
      dispatch(
        setSuccessMessage({
          title: "Success",
          subTitle: "Job has been successfully updated",
        }),
      );
      callback();
    }
  };
}

export function bulkDeleteJob({ jobIds = [] }, callback) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true));

      const resp = await ApiService.invokeDelete(
        process.env.REACT_APP_API_URL + `/admin/api/secured/jobs`,
        {
          jobIds,
        },
      );

      dispatch(isLoading(false));

      if (resp.status == 200) {
        dispatch(
          setSuccessMessage({
            title: "Success",
            subTitle: "Item(s) deleted",
          }),
        );
      }

      if (callback) callback();
    } catch (e) {}
  };
}

export function fetchAllJob({ query, page = 0, limit = 3 }, callback) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL +
        `/admin/api/secured/jobs?query=${query}&page=${page}&limit=${limit}`,
    );

    dispatch(isLoading(false));

    if (resp.status == 200) {
      const { data } = resp.data;

      await dispatch({
        type: "FETCH_JOB_TABLE",
        payload: data,
      });

      if (callback)
        callback({
          filteredData: data.filteredData,
          totalFiltered: data.filteredData?.length,
          total: data.total,
        });
    }
  };
}

/**
 *
 * @param {object} map
 * @param {function} callback
 */
export function getJob({ jobId }, callback) {
  return async (dispatch) => {
    dispatch(isLoading(true));

    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL + `/admin/api/secured/jobs/${jobId}`,
    );

    dispatch(isLoading(false));

    if (resp.status == 200) {
      callback(resp.data.data);
    }
  };
}
